<template>
  <div class="sthxMsgPage">
    <van-cell-group class="forestInput">
      <van-field
        v-model="baseData.yztNd"
        readonly
        :label="$t('common.yearTit') + '：'"
      />
      <van-field
        v-model="baseData.xianName"
        readonly
        :label="$t('common.politicalTit') + '：'"
      />
      <!-- <van-field v-model="baseData.area" readonly label="类型：" /> -->
      <van-field
        v-model="baseData.remarks"
        rows="3"
        autosize
        type="textarea"
        readonly
        :label="$t('common.explainTit') + '：'"
      />
    </van-cell-group>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "sthxMsg",
  data() {
    return {
      sthxId: "", //生态红线Id
      baseData: {},
      refreshPage: false,
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  components: {
    refreshPage,
  },
  mounted() {
    document.title = "生态红线信息";
    this.clientType = getDeviceType();

    this.$nextTick(function () {
      this.sthxId = this.$route.query.commonId;
      if (this.sthxId == undefined) {
        this.sthxId = this.param.id;
      }
      this.initPage();
    });
    // this.sthxId = "10";
    //  this.initPage();
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .geoHongxian({
          objid: _this.sthxId,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.sthxId = _this.param.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.sthxMsgPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  .fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }
  .forestInput {
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>